import React, {Suspense, useContext, useEffect} from 'react';
// @ts-ignore
import {BrowserRouter, Route, Switch} from 'react-router-dom';
// @ts-ignore
import {Container} from 'shards-react';

import './i18n'
import MainContainer from "./containers/main/MainContainer";
import {GlobalDataContext} from "./contexts/GlobalDataContext";
import DataService from "./services/DataService";
import {RegionSelectedContextProvider} from "./contexts/RegionSelectedContext";

const Router: React.FC = () => {

    // @ts-ignore
    const { setData } = useContext(GlobalDataContext);

    useEffect(() => {
        const fetchData = async () => {
            const { europeRecords, latamRecords, latamHerfindahlRecords, latamConcentrationRecords}: any = await DataService.fetchInitialData();

            setData(
              europeRecords,
              latamRecords,
              latamHerfindahlRecords,
              latamConcentrationRecords
            );
        };
        fetchData();
    }, []);

    return (
        <BrowserRouter basename={process.env.REACT_APP_BASENAME || ''}>
            <Suspense fallback={null}>
                <Container fluid style={{height: '100vh'}}>
                    <Switch>
                        <Route exact path={'/rankings'} component={MainContainerWrapper} />
                    </Switch>
                </Container>
            </Suspense>
        </BrowserRouter>
    );
};


export const MainContainerWrapper: React.FC = () => {
    return(
        <RegionSelectedContextProvider>
            <MainContainer />
        </RegionSelectedContextProvider>
    )
};

export default Router;
